import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  body14BoldStyles,
  body14Styles,
  body16BoldStyles,
  body16MainStyles,
  h5Styles,
  smallcapsBold14Styles,
} from "@constants/typography"
import React from "react"
import { useTimer } from "react-timer-hook"
import styled from "styled-components"

const Container = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  height: 56px;
  background-color: #ff5f00;
`

const Content = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
`

const Text = styled.div`
  ${h5Styles};
  margin-right: 24px;
  font-size: 14px;
  color: ${colors.offWhite};

  @media ${breakpoints.laptop} {
    margin-right: 64px;
    font-size: 16px;
    color: ${colors.offWhite};
  }
`

const Timer = styled.div`
  display: flex;
`

const TimerText = styled.div`
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
`

const TimerTime = styled.div`
  ${body14BoldStyles};
  margin: 0 12px;
  color: ${colors.offWhite};

  @media ${breakpoints.laptop} {
    ${body16BoldStyles};
    margin: 0 16px;
    color: ${colors.offWhite};
  }
`

const TimerLabel = styled.div`
  ${body14Styles};
  color: ${colors.backgroundGray70};

  @media ${breakpoints.laptop} {
    ${body16MainStyles};
    color: ${colors.backgroundGray70};
  }
`

const TimerSeparator = styled.div`
  ${smallcapsBold14Styles};
  padding-bottom: 18px;
  color: ${colors.offWhite};

  @media ${breakpoints.laptop} {
    padding-bottom: 20px;
  }
`

interface CountdownTimerProps {
  eventEnd?: string
  eventStart: string
  textAfterEvent?: string
  textBeforeEvent: string
  textDuringEvent?: string
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  eventEnd,
  eventStart,
  textAfterEvent,
  textBeforeEvent,
  textDuringEvent,
}) => {
  const [text, setText] = React.useState(textBeforeEvent)

  const eventStartTime = new Date(eventStart)
  const eventEndTime = eventEnd ? new Date(eventEnd) : null

  const { days, hours, isRunning, minutes, seconds, totalSeconds } = useTimer({
    expiryTimestamp: eventStartTime,
    onExpire: () => {
      setText(textDuringEvent || textBeforeEvent)
    },
  })

  if (eventEndTime) {
    useTimer({
      expiryTimestamp: eventEndTime,
      onExpire: () => {
        setText(textAfterEvent || textBeforeEvent)
      },
    })
  }

  return (
    <Container>
      <Content>
        <Text>{text}</Text>
        <Timer>
          <TimerText>
            <TimerTime>{days}</TimerTime>
            <TimerLabel>Days</TimerLabel>
          </TimerText>
          <TimerSeparator>:</TimerSeparator>
          <TimerText>
            <TimerTime>{hours}</TimerTime>
            <TimerLabel>Hrs</TimerLabel>
          </TimerText>
          <TimerSeparator>:</TimerSeparator>
          <TimerText>
            <TimerTime>{minutes}</TimerTime>
            <TimerLabel>Mins</TimerLabel>
          </TimerText>
          <TimerSeparator>:</TimerSeparator>
          <TimerText>
            <TimerTime>{seconds}</TimerTime>
            <TimerLabel>Secs</TimerLabel>
          </TimerText>
        </Timer>
      </Content>
      <style>
        {`
          #wi-country-selector-button {
            top: 14px !important;
            left: initial;
            right: 8px !important;
            transform: initial;
          }
        `}
      </style>
    </Container>
  )
}

export default CountdownTimer
